import React, { useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import Timeline from "./Timeline";
import ProjectInfo from "./ProjectInfo";
import WorkflowLogs from "./WorkflowLogs";
import { proxyAPI } from "../../proxyAPI";
import ContactsIcon from "../../../assets/icons/contact_edit.svg2";
import FullScreenLoadingIndicator from "../../Common/FullScreenLoadingIndicator";
import WhiteButtonsContainer from "../../Common/WhiteButtonsContainer";
import { faCircleStop, faFilter } from "@fortawesome/free-solid-svg-icons";
import ProcessesIcon from "../../../assets/icons/process_reports.svg2";
import Subheading from "../../Common/Subheading";
import HelpButton from "../../HelpContent/HelpButton";
import WhiteButtonDropdown from "../../Common/WhiteButtonDropdown";
import { faRectangleList } from "@fortawesome/free-regular-svg-icons";

const { baseUrl: baseURL } = JSON.parse(
  document.querySelector("#app").dataset.page
).props;

export default function Processes() {
  const [project, setProject] = useState(null);
  const [processes, setProcesses] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showLogs, setShowLogs] = useState({ GUID: null, runtimeID: null });
  const { projectID } = useParams();
  const [serachParams] = useSearchParams();

  const loader = async (
    startAt,
    endAt,
    status,
    offset,
    limit = Number(serachParams.get("limit")) || 10
  ) => {
    setLoading(true);
    const data = await proxyAPI({
      prefix: "logic/workflows/api",
      url: `/processes?${
        projectID ? `id=${projectID}` : ""
      }&start_at=${startAt.toISOString()}&end_at=${endAt.toISOString()}&offset=${offset}&limit=${limit}&status=${status}`,
    });
    setTimeout(() => {
      if (data?.processes) {
        setTotal(data.total);
        setProcesses(data.processes);
        setProject(data.project);
      }
      setLoading(false);
    }, 500);
  };

  const stopProcess = async (id, callback) => {
    const data = await proxyAPI({
      prefix: "logic/workflows/api",
      url: `/stop-process/${id}`,
      setLoading,
    });
    if (data) {
      callback();
      toast.success("Process stopped");
    }
  };

  return (
    <>
      <FullScreenLoadingIndicator loading={loading} />
      <div>
        <div className="d-flex justify-content-between">
          <div className="d-flex align-items-center">
            <Subheading
              Icon={ProcessesIcon}
              heading="Processes"
              subheading="See how your projects are running ."
            />
          </div>
          <div className="d-flex justify-content-end">
            <WhiteButtonDropdown
              toggleHeading={"Actions"}
              toggleSubheading={"Processes"}
            >
              <WhiteButtonsContainer
                buttons={[
                  ...(project
                    ? [
                        {
                          icon: ContactsIcon,
                          as: "a",
                          heading: "Edit",
                          subheading: "Project",
                          to: `${baseURL}/workflows/builder/${project?.ID}`,
                          target: `project_${project?.ID}`,
                          title: "Edit project in a new window",
                        },
                      ]
                    : []),
                  {
                    icon: ContactsIcon,
                    as: "RRLink",
                    heading: "Projects",
                    subheading: "Manage",
                    to: "/projects",
                  },
                  {
                    icon: ContactsIcon,
                    as: "RRLink",
                    heading: "Inbounds",
                    subheading: "Manage",
                    to: "/inbounds",
                  },
                ]}
              />
            </WhiteButtonDropdown>
          </div>
        </div>
        {!!project && (
          <>
            <div className="my-3 ">
              <ProjectInfo project={project} />
            </div>
            <hr className="text-secondary" />
          </>
        )}
        <div className="my-3 ">
          <Timeline
            key={projectID}
            title={
              <span className="text-white">
                {project ? "" : "All "}
                Processes
              </span>
            }
            loader={loader}
            processes={processes}
            total={total}
            // eslint-disable-next-line react/no-unstable-nested-components
            link={(process, callback = () => {}) => (
              <>
                {process.Project && (
                  <td title="Show project in builder">
                    <div className="small bg-transparent">Project </div>
                    <a
                      className="bg-transparent"
                      target={`project_${process.Project.ID}`}
                      href={`${baseURL}/workflows/builder/${process.Project.ID}`}
                    >
                      {process.Project.Label}
                    </a>
                    <Link
                      title="show processes from this project"
                      className="btn btn-link border-0 btn-sm bg-transparent"
                      to={{
                        pathname: `/reporting/processes/${process.Project.ID}`,
                        search: serachParams.toString(),
                      }}
                    >
                      <FontAwesomeIcon icon={faFilter} />
                    </Link>
                  </td>
                )}
                <td>
                  <div className="small bg-transparent">Process</div>
                  <Link
                    to={{
                      pathname: `/reporting/processes/${process.ProjectID}/process/${process.ID}`,
                      search: serachParams.toString(),
                    }}
                    className="btn btn-link btn-sm p-0 align-baseline bg-transparent"
                    title="Show process details"
                  >
                    {process.GUID}
                  </Link>
                  {process.IsActive && (
                    <button
                      title="Stop process"
                      type="button"
                      className="btn btn-link link-danger p-0 ms-2 bg-transparent"
                      onClick={() => stopProcess(process.GUID, callback)}
                    >
                      <FontAwesomeIcon
                        className="text-danger"
                        icon={faCircleStop}
                      />
                    </button>
                  )}
                  <button
                    type="button"
                    title="Show process logs"
                    className="btn btn-link p-0 ms-2 bg-transparent"
                    onClick={() => setShowLogs({ GUID: process.GUID })}
                  >
                    <FontAwesomeIcon icon={faRectangleList} />
                  </button>
                </td>
                {process.StoppedBy ? (
                  <td title="Process stopped by">
                    <div className="small">Stopped by</div>
                    {process.StoppedBy}
                  </td>
                ) : (
                  <td></td>
                )}
              </>
            )}
          />
        </div>
      </div>
      <WorkflowLogs
        {...showLogs}
        handleClose={() => setShowLogs({ GUID: null, runtimeID: null })}
      />
    </>
  );
}
